import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { auth } from '../actions';

import wordmark from '../pinstripe-wordmark.png';

class Signup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      username: '',
      email: '',
      password: '',
    };
  }
  componentDidMount() {
    window.analytics.page('Sign Up Viewed');
  }

  handleUsername = e => {
    this.setState({ username: e.target.value });
  }

  handleEmail = e => {
    this.setState({ email: e.target.value });
  }

  handlePassword = e => {
    this.setState({ password: e.target.value });
  }

  onSubmit = e => {
    e.preventDefault();
    this.props.register(this.state.username, this.state.email, this.state.password);
    window.analytics.track("User Signup", {
      username: this.state.username,
      email: this.state.email,
    });
    this.props.history.push('/apps');
  }

  handleClose = e => {
    this.props.history.push('/apps');
  }

  render() {
    let required = true;

    if (this.props.isAuthenticated) {
      this.props.history.push('/apps');
    }
    return (
      <div className="auth signup">
        <form className="signup" onSubmit={this.onSubmit}>
          <Link className="btn_close" to="" onClick={this.handleClose}>
            <i className="fa fa-angle-right"></i>
            <i className="fa fa-angle-left"></i>
          </Link>
          <fieldset>
            <legend>
              <img src={wordmark} className="App-logo" alt="pinstripe wordmark" />
            </legend>
            {this.props.errors.length > 0 && (
              <ul>
                {this.props.errors.map(error => (
                  <li key={error.field}>{error.message}</li>
                ))}
              </ul>
                )}
            <p>
              <label htmlFor="username">Select your Username</label>
              <input
                type="text" id="username" name="username"
                required={required}
                onChange={this.handleUsername} />
            </p>
            <p>
              <label htmlFor="username">Enter your Work Email</label>
              <input
                type="text" id="email" name="email"
                required={required}
                onChange={this.handleEmail} />
            </p>
            <p>
              <label htmlFor="password">Set your Password</label>
              <input
                type="password" id="password" name="password"
                required={required}
                onChange={this.handlePassword}/>
            </p>
            <p>
              <button className="btn" type="submit">Create Account</button>
            </p>
            <p>
              Already have an account? <Link className="link" to="/signin">Sign In</Link>
            </p>
          </fieldset>
        </form>
        <div className="side-img">
          <h1>"The best way to get started is to quit talking and start doing"</h1>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  let errors = [];
  if (state.auth.errors) {
    errors = Object.keys(state.auth.errors).map(field => {
      return {field, message: state.auth.errors[field]};
    });
  }
  return {
    errors,
    isAuthenticated: state.auth.isAuthenticated
  };
}

const mapDispatchToProps = dispatch => {
  return {
    register: (username, email, password) => dispatch(auth.register(username, email, password)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Signup);


// WEBPACK FOOTER //
// ./src/components/Signup.js